import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Currency } from "@nestcoinco/hyper-api-gateway-api-client";

import { QUERY_KEYS } from "../constants";
import { handleGetMyWallets } from "../../api-clients/walletAccountsClient";
import { handleGetGemResponse } from "../../api-clients/walletGemsClient";
import useAuth from "../../hooks/useAuth";

type UseBalancesQueryParams = {
  currency?: Currency;
  enabled?: boolean;
};

function useBalancesQuery(params?: UseBalancesQueryParams) {
  const { isLoggedIn } = useAuth();
  const { currency = Currency.HPR, enabled } = params || {};
  const isEnabled = (enabled ?? isLoggedIn) && isLoggedIn;

  const { data: walletList, isLoading: isHprLoading } = useQuery({
    queryKey: [QUERY_KEYS.WALLET.WALLET_LIST],
    queryFn: handleGetMyWallets,
    enabled: isEnabled,
  });

  const { data: gemResponse, isLoading: isGemLoading } = useQuery({
    queryKey: [QUERY_KEYS.WALLET.GEM_RESPONSE],
    queryFn: handleGetGemResponse,
    enabled: isEnabled,
  });

  const walletRecords = walletList?.records;
  const hprWallet = useMemo(
    () =>
      walletRecords &&
      walletRecords.find((record) => record.asset === currency),
    [currency, walletRecords],
  );

  return {
    hprBalance: hprWallet?.balance.availableBalance,
    gemBalance: gemResponse?.balance,
    isLoading: isGemLoading || isHprLoading,
  };
}

export default useBalancesQuery;
